import { Action } from 'redux';
import { ArchiviState } from './models';
import { ArchiviActions } from './actionTypes';

const initialState: ArchiviState = {
    filtro: { tipiDocumento: [], anniConArchivi: [], refreshCache: true },
    archivi: { lista: [], page: 1, pageSize: 100, itemsCount: 0, refreshCache: true }
}

export default (
    state: ArchiviState = initialState, 
    incomingAction: Action
): ArchiviState => {
    
    const action = incomingAction as ArchiviActions;
    switch (action.type) {
        case 'core/MODIFICA_ANAGRAFICA':
            return initialState;
        case 'archivi/LOAD_FILTRO': 
            return { 
                ...state,
                filtro: {
                    ...action.value,
                    refreshCache: false
                }
            };
        case 'archivi/LOAD_ARCHIVI':
            return {
                ...state,
                archivi: { 
                    lista: action.value.results, 
                    page: action.page, 
                    pageSize: action.value.pageSize,
                    itemsCount: action.value.count,
                    refreshCache: false
                }
            };
        default: return state;
    }
};